import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Tabs } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link, useHistory } from "react-router-dom";
import { loginApi, verifySchoolApi } from "../../../api/loginStudentApi";
import logo from "../../../assets/icon/logo.png";
import { LoginContext } from "../../../store/loginStore";
import Footer from "../footer/footer";

const { TabPane } = Tabs;
const { TextArea } = Input;
export default function Login() {
  const history = useHistory();

  const [isNextClicked, setIsNextClicked] = useState(false);
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);

  const { loginC, dispatchLogin } = LoginContext();

  const { schoolData, studentData, multiDLogin, loader, err, supportData } =
    loginC;

  const isSchoolData = schoolData.status === "201";

  console.log(isSchoolData);

  console.log("err", err);
  useEffect(() => {
    console.log("err", err);
    if (err) {
      setIsNextClicked(false);
      setIsSubmitClicked(false);
    } else if (isSchoolData) {
      setIsNextClicked(false);
    }
  }, [err, isSchoolData, isNextClicked, isSubmitClicked]);

  const handleLogin = (value) => {
    if (!isSchoolData) {
      localStorage.setItem("sch_code", value.sch_code);
      verifySchoolApi(value, dispatchLogin);
      setIsNextClicked(true);
    } else if (isSchoolData) {
      loginApi(value, dispatchLogin, history);
    } else if (!isSchoolData && !err) {
      setIsSubmitClicked(true);
    }
  };

  const handleLoginBack = () => {
    console.log("run");
    setIsNextClicked(false);
    dispatchLogin({ type: "RESET_LOGIN_DATA" });
    localStorage.removeItem("sch_code");
  };
  const myAnchor = useRef();
  return (
    <>
      <div className="login-page">
        <div className="login-logo">
          <a href="https://mymemorymentor.com/mappr/">
            <LazyLoadImage alt="" effect="blur" src={logo} />
          </a>
        </div>
        <div className="login-wrapper">
          <div className="login-form">
            <div className="login-form-head">
              <span>
                {isSchoolData ? "Welcome" : "What describes you best?"}
              </span>
            </div>
            <Form validateTrigger="onSubmit" onFinish={handleLogin}>
              <Tabs
                defaultActiveKey="2"
                style={{ display: !isSchoolData ? "block" : "none" }}
                onChange={(val) => {
                  val === "1" &&
                    window.location.assign(
                      "https://admin.mymemorymentor.com/login",
                    );
                }}
              >
                <TabPane tab="ASSESSOR" key="1">
                  <Form.Item
                    name="sch_code"
                    rules={[
                      {
                        required: true,
                        message: "Please input your school code",
                      },
                      {
                        pattern: /^\S+$/,
                        message: "space not allowed",
                      },
                    ]}
                  >
                    <Input disabled={isSchoolData} placeholder="School Code" />
                  </Form.Item>
                </TabPane>
                <TabPane tab="STUDENT" key="2">
                  <Form.Item
                    name="sch_code"
                    rules={[
                      {
                        required: true,
                        message: "Please input your school code",
                      },
                      {
                        pattern: /^\S+$/,
                        message: "space not allowed",
                      },
                    ]}
                  >
                    <Input disabled={isSchoolData} placeholder="School Code" />
                  </Form.Item>
                </TabPane>
              </Tabs>

              {isSchoolData && (
                <>
                  <Form.Item
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Email address",
                      },
                      {
                        pattern:
                          /^([a-zA-Z\d_.-]{2,})@([a-zA-Z\d-]{2,})\.([a-zA-Z]{2,})(\.[a-zA-Z]{2,})?$/,
                        message: "Please input correct Email address",
                      },
                      {
                        max: 64,
                        message: "Only 64 letters allow to input",
                      },
                      {
                        pattern: /^\S+$/,
                        message: "space not allowed",
                      },
                    ]}
                  >
                    <Input placeholder="Parent Email" />
                  </Form.Item>

                  <Form.Item
                    name="firstname"
                    rules={[
                      {
                        max: 32,
                        message: "Only 32 letters allow to input",
                      },
                      {
                        required: true,
                        message: "Please input your First Name",
                      },
                      {
                        pattern: /^([a-zA-Z]{2,})?$/,
                        message: "Number or any special character not allowed",
                      },
                      {
                        pattern: /^\S+$/,
                        message: "space not allowed",
                      },
                    ]}
                  >
                    <Input placeholder="First Name" />
                  </Form.Item>

                  <Form.Item
                    name="lastname"
                    rules={[
                      {
                        max: 32,
                        message: "Only 32 letters allow to input",
                      },
                      {
                        required: true,
                        message: "Please input your Last Name",
                      },
                      {
                        pattern: /^([a-zA-Z]{2,})?$/,
                        message: "Number or any special character not allowed",
                      },
                      {
                        pattern: /^\S+$/,
                        message: "space not allowed",
                      },
                    ]}
                  >
                    <Input placeholder="Last Name" />
                  </Form.Item>
                </>
              )}

              <div className="login-btn-wrap">
                {isSchoolData && (
                  <Button className="custom-btn one" onClick={handleLoginBack}>
                    Back
                  </Button>
                )}
                {console.log("isSubmitClicked", isSubmitClicked)}
                {console.log("isNextClicked", isNextClicked)}
                <Form.Item>
                  <Button
                    htmlType="submit"
                    className="custom-btn"
                    disabled={isSubmitClicked || isNextClicked}
                  >
                    {loader ? (
                      <LoadingOutlined />
                    ) : !isSchoolData ? (
                      "Next"
                    ) : (
                      "Login"
                    )}
                  </Button>
                </Form.Item>
              </div>
            </Form>
            {isSchoolData && (
              <span className="new-user-link">
                New user?
                <Link to="/signup">Sign Up</Link>
              </span>
            )}
          </div>
          <Footer
            supportData={supportData}
            loader={loader}
            LoadingOutlined={LoadingOutlined}
            dispatchLogin={dispatchLogin}
          />
        </div>
      </div>

      <Modal
        visible={!!multiDLogin}
        className="sml-modal"
        // title="SURVEY"
        footer={
          <div className="sml-footer">
            <button
              className="custom-btn ok"
              onClick={() =>
                dispatchLogin({ type: "MULTI_LOGIN", payload: "" })
              }
            >
              Ok
            </button>
          </div>
        }
      >
        <h2 style={{ textAlign: "center" }}>{multiDLogin}</h2>
      </Modal>
    </>
  );
}
